import styled from 'styled-components';

export const VideoComponent = styled.video<{ loaded: boolean }>`
  ${(props) => !props.loaded && 'display: none;'}
  max-width: 100%;
`;
